import * as joint from "@joint/core";
import {AvoidLib, ConnRef} from "libavoid-js";
import {Polygon, Router} from "libavoid-js";
import {g, dia } from "@joint/core";
import {AvoidRouter, VerticePoint} from "@app/netscope/netscope-common-flowview/misc/AvoidRouter";
import {
  OptimizedAppsGroupsRouter, RoutingOptions,
  VerticePointsWithCellsVersion
} from "@app/netscope/netscope-common-flowview/misc/OptimizedAppsGroupsRouter";


export class FlatAppsGroupsRouter extends OptimizedAppsGroupsRouter {

  constructor(graph: joint.dia.Graph, options: {
    shapeBufferDistance?: number,
    idealNudgingDistance?: number,
    paper?: joint.dia.Paper
  } = {}) {

    super(graph, options);
  }

  override computeAllVertices = (paper: dia.Paper, options: RoutingOptions) => {
    console.log("computeAllVertices()");

    // @ts-ignore
    this.lastComputedVersion = this.graph.version;
    const router: Router = this.generateNewRouter();

    // console.log("Adding a shape.");

    let obstaclesShapes = [];
    let obstacles: Polygon[] = [];

    // Process Apps groups and compute inter Apps groups vertices
    let allElements = this.graph.getElements();

    let appGroupsIndex: Map<string, dia.Element> = new Map();
    allElements.forEach((el) => {
      appGroupsIndex.set(el.id.toString(), el);
    })

    allElements
      .forEach((el) => {
        let elBBox = el.getBBox();
        let p1 = new this.Avoid.Point(elBBox.x, elBBox.y);
        let p2 = new this.Avoid.Point(elBBox.x + elBBox.width, elBBox.y + elBBox.height);
        const rectangle = new this.Avoid.Rectangle(p1, p2);
        obstaclesShapes.push(...[p1, p2, rectangle]);
        obstacles.push(rectangle);
        const shapeRef = new this.Avoid.ShapeRef(router, rectangle);
      });

    let mapParentLinks = new Map<string, joint.dia.Link>();

    for (let link of this.graph.getLinks()) {
      // @ts-ignore
      link.sourceBBox = link.getSourceCell().getBBox();
      // @ts-ignore
      link.targetBBox = link.getTargetCell().getBBox();
      // @ts-ignore
      mapParentLinks.set(link.id, link);
    }

    // Compute all vertices of inter apps-groups links
    let allConnEnds = [];
    let allConnRefs = [];
    let connRefsMap = new Map<string | number, ConnRef>();

    for (let link of this.graph.getLinks()) {
      let anchors = this.decideAnchors(link.getSourceElement(), link.getTargetElement());

      let srcAnchorWithMargin = this.computeMargin(anchors.src, link.getSourceElement().getCenter(), 30);
      let dstAnchorWithMargin = this.computeMargin(anchors.dst, link.getTargetElement().getCenter(), 30);

      const src = new this.Avoid.ConnEnd(new this.Avoid.Point(srcAnchorWithMargin.x, srcAnchorWithMargin.y));
      const dst = new this.Avoid.ConnEnd(new this.Avoid.Point(dstAnchorWithMargin.x, dstAnchorWithMargin.y));
      const conn = new this.Avoid.ConnRef(router, src, dst);

      allConnRefs.push(conn);
      connRefsMap.set(link.id, conn);
    }

    // Compute positions
    console.time("processTransaction");
    router.processTransaction();
    console.timeEnd("processTransaction");

    // Get all the apps-groups routes
    for (let link of this.graph.getLinks().values()) {
      let linkConnRef = connRefsMap.get(link.id);
      const route = linkConnRef.displayRoute();
      let vertices: VerticePoint[] = [];
      for (let i = 0; i < route.size(); i++) {
        const {x, y} = route.get_ps(i);
        vertices.push({x: x, y: y});
      }

      let source = link.getSourceElement();
      let target = link.getTargetElement();

      // @ts-ignore
      let versionedVertices = new VerticePointsWithCellsVersion(source, target, true, vertices);

      this.linksPrecomputedVertices.set(link.id.toString(), versionedVertices);
    }

    this.Avoid.destroy(router);
  }
}
